import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { Tag } from "@msuite/ui/tag";
import { formatInvoiceAmount, formatInvoiceRate } from "@/components/incoming-invoices";
import type { CostAllocationRow } from "./cost-allocation-row";
import { CostAllocationRowActions } from "./cost-allocation-row-actions";

const columnHelper = createColumnHelper<CostAllocationRow>();

export const columns = [
	columnHelper.accessor((row) => row.costCenter.number, {
		id: "costCenterNumber",
		header: localized("cost_centers.number"),
		cell: (cell) => (
			<Tag
				color={cell.row.original.costCenter.color}
				variant="plain"
			>
				{cell.getValue()}
			</Tag>
		),
		size: 140,
	}),
	columnHelper.accessor((row) => row.costCenter.name, {
		id: "costCenterName",
		header: localized("cost_centers.name"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("amount", {
		id: "amount",
		header: localized("incoming_invoices.amount"),
		cell: (cell) => formatInvoiceAmount(cell.getValue(), cell.row.original.currency),
		size: 150,
	}),
	columnHelper.accessor("share", {
		id: "share",
		header: localized("incoming_invoices.share"),
		cell: (cell) => {
			const share = cell.getValue();
			return formatInvoiceRate(share === null ? null : Math.round(share * 100) / 100);
		},
		size: 110,
	}),
	createRowActions(CostAllocationRowActions),
];
